import type { Endpoint, Request, RequestArgs, Route } from '../types.no-deps'
import type { ActionWithAssignees, ScheduleWithAssignees } from '../../../shared/domain/schedule/types.no-deps'

export const route: Route = { method: 'GET', pattern: '/api/schedules' }

type Params = never
type Body = never
type Query = { procedure: number; workflow: number }
type Output = {
    schedules: Array<ScheduleWithAssignees | ActionWithAssignees>
}

export type GetEndpoint = Endpoint<Params, Body, Query, Output>

export const getRequest = (request: Request, args: RequestArgs<GetEndpoint>) => request<GetEndpoint>(route, args)
